import { BeneficiarioRCMDocs } from './BeneficiarioRCM';
import { CPADocs } from './CPA';
import { dependentesIRDocs } from './DependentesIR';
import { HerdeiroCotasDocs } from './HerdeiroCotas';
import { HerdeiroLegalAtivoDocs } from './HerdeiroLegalAtivo';
import { MAIDocs } from './MAI';
import { MATDocs } from './MAT';
import { PPIDocs } from './PPIDocs';
import { PPMDocs } from './PPMDocs';
import { resgateDocs } from './ResgatePlanoB';
import { ResgateTaesaDocs } from './ResgateTaesa';
import { RevisaoCPADocs } from './RevisaoCPA';
import { SaldoMATDocs } from './SaldoMAT';
import { TempoContribuicaoDocs } from './TempoContribuicaoDocs';
import { RCMBDocs } from './RCMBDocs';
import { RCMADocs } from './RCMADocs';
import { MATTemporariaDocs } from './MATTemporariaDocs';
import { ContConjulgadaDocs } from './ContConjulgadaDocs';
import { IsencaoDocs } from './IsencaoDocs';
import { HerdeiroLegalANDocs } from './HerdeiroLegalANDocs';
import { MAIOptanteDocs } from './MAIOptanteDocs';
import { MAIANDocs } from './MAIAN';
import { ContConjulgadaFinDocs } from './ContConjulgadaFinDocs';
import { PPMHerdeiroDocs } from './PPMHerdeiroDocs';
import { IsencaoResgateDocs } from './IsencaoResgateDocs';

export default {
  BeneficiarioRCMDocs: BeneficiarioRCMDocs(),
  CPADocs: CPADocs(),
  dependentesIRDocs: dependentesIRDocs(),
  HerdeiroCotasDocs: HerdeiroCotasDocs(),
  HerdeiroLegalAtivoDocs: HerdeiroLegalAtivoDocs(),
  MAIDocs: MAIDocs(),
  MATDocs: MATDocs(),
  PPIDocs: PPIDocs(),
  PPMDocs: PPMDocs(),
  resgateDocs: resgateDocs(),
  ResgateTaesaDocs: ResgateTaesaDocs(),
  RevisaoCPADocs: RevisaoCPADocs(),
  TempoContribuicaoDocs: TempoContribuicaoDocs(),
  SaldoMATDocs: SaldoMATDocs(),
  RCMBDocs: RCMBDocs(),
  RCMADocs: RCMADocs(),
  MATTemporariaDocs: MATTemporariaDocs(),
  ContConjulgadaDocs: ContConjulgadaDocs(),
  IsencaoDocs: IsencaoDocs(),
  IsencaoResgateDocs: IsencaoResgateDocs(),
  HerdeiroLegalANDocs: HerdeiroLegalANDocs(),
  MAIOptanteDocs: MAIOptanteDocs(),
  MAIANDocs: MAIANDocs(),
  ContConjulgadaFinDocs: ContConjulgadaFinDocs(),
  PPMHerdeiroDocs: PPMHerdeiroDocs(),
};
